import { memdbRequest } from "./index.js";
export var CheckValuesType;
(function (CheckValuesType) {
    CheckValuesType[CheckValuesType["Members"] = 1] = "Members";
    CheckValuesType[CheckValuesType["AnnualMeeting"] = 2] = "AnnualMeeting";
    CheckValuesType[CheckValuesType["ConstituentMeeting"] = 3] = "ConstituentMeeting";
    CheckValuesType[CheckValuesType["Statutes"] = 4] = "Statutes";
    CheckValuesType[CheckValuesType["AnnualReport"] = 5] = "AnnualReport";
    CheckValuesType[CheckValuesType["AnnualGift"] = 6] = "AnnualGift";
    CheckValuesType[CheckValuesType["ClassList"] = 7] = "ClassList";
})(CheckValuesType || (CheckValuesType = {}));
export var MailType;
(function (MailType) {
    MailType[MailType["Unknown"] = -1] = "Unknown";
    MailType[MailType["AccountStart"] = 1] = "AccountStart";
    MailType[MailType["NewSchoolClassPassword"] = 2] = "NewSchoolClassPassword";
    MailType[MailType["NewSchoolClassPasswordToSome"] = 3] = "NewSchoolClassPasswordToSome";
    MailType[MailType["NotifyDistrictSchoolClubCreated"] = 4] = "NotifyDistrictSchoolClubCreated";
    MailType[MailType["NotifyShopOfNewClub"] = 5] = "NotifyShopOfNewClub";
    MailType[MailType["GiftRequest"] = 6] = "GiftRequest";
    MailType[MailType["NotifyContactOfApprovedClub"] = 7] = "NotifyContactOfApprovedClub";
    MailType[MailType["NotifyMemberServiceOfUploadedDocument"] = 8] = "NotifyMemberServiceOfUploadedDocument";
    MailType[MailType["MainMemberTransferConfirmation"] = 10] = "MainMemberTransferConfirmation";
    MailType[MailType["TfsNotification"] = 11] = "TfsNotification";
    MailType[MailType["ClubUpdatedNotification"] = 12] = "ClubUpdatedNotification";
    MailType[MailType["DistrictUpdatedNotification"] = 13] = "DistrictUpdatedNotification";
    MailType[MailType["CashierMoved"] = 14] = "CashierMoved";
    MailType[MailType["ClubInactiveReminder"] = 15] = "ClubInactiveReminder";
    MailType[MailType["CashierAppointed"] = 16] = "CashierAppointed";
    MailType[MailType["TournamentCommentSet"] = 17] = "TournamentCommentSet";
    MailType[MailType["ClubActivityChanged"] = 18] = "ClubActivityChanged";
    MailType[MailType["SendMembersReggedToSchoolClub"] = 19] = "SendMembersReggedToSchoolClub";
    MailType[MailType["MailToYes2ChessTeamCaptains"] = 20] = "MailToYes2ChessTeamCaptains";
    MailType[MailType["SchoolClubMemberNotes"] = 21] = "SchoolClubMemberNotes";
    MailType[MailType["NewClubMailToSchoolClub"] = 22] = "NewClubMailToSchoolClub";
    MailType[MailType["RegisterTeamMatchSetupConfirmationToTeamLeader"] = 23] = "RegisterTeamMatchSetupConfirmationToTeamLeader";
    MailType[MailType["NewPassword"] = 24] = "NewPassword";
    MailType[MailType["SchoolClubApprovedButNotGift"] = 25] = "SchoolClubApprovedButNotGift";
    MailType[MailType["SchoolClubSendInTheRestToBeApproved"] = 26] = "SchoolClubSendInTheRestToBeApproved";
    MailType[MailType["SchoolClubNewAndHavntSentInAnything"] = 27] = "SchoolClubNewAndHavntSentInAnything";
    MailType[MailType["SchoolClubExistingButHaveNotSentInAnyting"] = 28] = "SchoolClubExistingButHaveNotSentInAnyting";
    MailType[MailType["Schackfyran_MailNotApprovedYet"] = 29] = "Schackfyran_MailNotApprovedYet";
    MailType[MailType["Y2C_MailNotApprovedYet"] = 30] = "Y2C_MailNotApprovedYet";
    MailType[MailType["UnsubscribeTournament"] = 31] = "UnsubscribeTournament";
    MailType[MailType["UnregisterSchoolMail"] = 32] = "UnregisterSchoolMail";
    MailType[MailType["TournamentRegistrationConfirmation"] = 33] = "TournamentRegistrationConfirmation";
    MailType[MailType["S4an_ApprovedButNotGift"] = 34] = "S4an_ApprovedButNotGift";
    MailType[MailType["Y2C_ApprovedButNotGift"] = 35] = "Y2C_ApprovedButNotGift";
    MailType[MailType["Y2C_RenewSpring"] = 36] = "Y2C_RenewSpring";
    MailType[MailType["S4an_RenewSpring"] = 37] = "S4an_RenewSpring";
    MailType[MailType["TwoFactorVerificationCode"] = 38] = "TwoFactorVerificationCode";
    MailType[MailType["SchoolClubVisitsSubmitted"] = 39] = "SchoolClubVisitsSubmitted";
    MailType[MailType["SignaturesNotApproved"] = 40] = "SignaturesNotApproved";
    MailType[MailType["DocumentNotApproved"] = 41] = "DocumentNotApproved";
    MailType[MailType["SignMembershipLink"] = 42] = "SignMembershipLink";
    MailType[MailType["NotifyContactPersonOfUploadedDocument"] = 46] = "NotifyContactPersonOfUploadedDocument";
    MailType[MailType["Exception"] = 100] = "Exception";
})(MailType || (MailType = {}));
export var MailStatus;
(function (MailStatus) {
    MailStatus[MailStatus["NotSent"] = 2] = "NotSent";
    MailStatus[MailStatus["Denied"] = 3] = "Denied";
    MailStatus[MailStatus["Delivered"] = 4] = "Delivered";
    MailStatus[MailStatus["Deleted"] = 5] = "Deleted";
    MailStatus[MailStatus["Bounced"] = 6] = "Bounced";
    MailStatus[MailStatus["Blocked"] = 7] = "Blocked";
    MailStatus[MailStatus["Read"] = 10] = "Read";
    MailStatus[MailStatus["ClickedLink"] = 11] = "ClickedLink";
    MailStatus[MailStatus["ReportedAsSpam"] = 12] = "ReportedAsSpam";
})(MailStatus || (MailStatus = {}));
export var MembershipType;
(function (MembershipType) {
    MembershipType[MembershipType["NotDefined"] = -1] = "NotDefined";
    // Payment types
    MembershipType[MembershipType["ReggedAfterWards"] = -3] = "ReggedAfterWards";
    MembershipType[MembershipType["PreReggedType"] = -2] = "PreReggedType";
    MembershipType[MembershipType["NormalType"] = 1] = "NormalType";
    //Membership types
    MembershipType[MembershipType["JuniorType"] = 2] = "JuniorType";
    MembershipType[MembershipType["AdultType"] = 3] = "AdultType";
    MembershipType[MembershipType["SeniorType"] = 4] = "SeniorType";
    MembershipType[MembershipType["SchackfyranType"] = 5] = "SchackfyranType";
    MembershipType[MembershipType["HonoraryMember"] = 10] = "HonoraryMember";
    // Not counted in statistics
    MembershipType[MembershipType["NoneOfficialMember"] = 120] = "NoneOfficialMember";
    MembershipType[MembershipType["CompetitionMembership"] = 121] = "CompetitionMembership";
    MembershipType[MembershipType["TfsMembership"] = 122] = "TfsMembership";
    MembershipType[MembershipType["ToBeMember"] = 130] = "ToBeMember";
})(MembershipType || (MembershipType = {}));
export var MainMembership;
(function (MainMembership) {
    MainMembership[MainMembership["NotDefined"] = -1] = "NotDefined";
    MainMembership[MainMembership["Main"] = 1] = "Main";
    MainMembership[MainMembership["Secondary"] = 2] = "Secondary";
})(MainMembership || (MainMembership = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["NotVerified"] = -1] = "NotVerified";
    PaymentType[PaymentType["NormalType"] = 1] = "NormalType";
    PaymentType[PaymentType["PreReggedType"] = -2] = "PreReggedType";
    PaymentType[PaymentType["ReggedAfterWards"] = -3] = "ReggedAfterWards";
})(PaymentType || (PaymentType = {}));
export var SpecialType;
(function (SpecialType) {
    SpecialType[SpecialType["Default"] = -1] = "Default";
    SpecialType[SpecialType["Country"] = 1] = "Country";
    SpecialType[SpecialType["Temp"] = 2] = "Temp";
    SpecialType[SpecialType["S4Temp"] = 3] = "S4Temp";
    SpecialType[SpecialType["SchoolTeamTemp"] = 4] = "SchoolTeamTemp";
})(SpecialType || (SpecialType = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Statutes"] = 2] = "Statutes";
    DocumentType[DocumentType["AnnualReport"] = 3] = "AnnualReport";
    DocumentType[DocumentType["AnnualMeeting"] = 4] = "AnnualMeeting";
    DocumentType[DocumentType["Membership"] = 5] = "Membership";
    DocumentType[DocumentType["ConstituentMeeting"] = 6] = "ConstituentMeeting";
    DocumentType[DocumentType["ClassList"] = 7] = "ClassList";
})(DocumentType || (DocumentType = {}));
export var ClubStatusLevel;
(function (ClubStatusLevel) {
    ClubStatusLevel[ClubStatusLevel["Gold"] = 1] = "Gold";
})(ClubStatusLevel || (ClubStatusLevel = {}));
export const TmpClub = 42171;
export function getClub(id, schema, token = "") {
    return memdbRequest.get(`/club/${id}`, {
        params: { schema },
        ...(token && { headers: { token } }),
    });
}
export function getClubs({ filter, ...params }, token = "") {
    return memdbRequest.get("/club", {
        params: { ...filter, ...params },
        ...(token && { headers: { token } }),
    });
}
export function getClubsWithUnapprovedSignatures(params, token = "") {
    return memdbRequest.get("/club/with-unapproved-signatures", {
        params: {
            ...params,
            documentTypes: params.documentTypes?.length
                ? params.documentTypes.join(",")
                : undefined,
        },
        ...(token && { headers: { token } }),
    });
}
export function createClub(body) {
    return memdbRequest.post("/club", { body });
}
export function updateClub(club) {
    return memdbRequest.post(`/club/${club.id}`, {
        body: { club },
    });
}
export function approveClub({ clubId, ...body }) {
    return memdbRequest.post(`/club/${clubId}/approve`, {
        body: { ...body },
    });
}
export function createMembership({ clubId, memberId, reg, }) {
    return memdbRequest.post(`/club/${clubId}/membership/${memberId}`, reg ? { body: { reg } } : {});
}
export function replaceMembership({ clubId, memberId, reg, oldreg, }) {
    return memdbRequest.post(`/club/${clubId}/membership/${memberId}`, { body: { reg, oldreg } });
}
export async function uploadDocuments({ clubId, documentType, files, generateFiles, }) {
    const body = new FormData();
    for (const file of [...files, ...((await generateFiles?.()) || [])]) {
        body.append("files", file);
    }
    return memdbRequest.post(`/club/${clubId}/document/${documentType}`, { body });
}
export const addComment = ({ clubId, comment, }) => memdbRequest.post(`/club/${clubId}/comment`, {
    body: { comment },
});
export const orderGift = ({ clubId, giftOption, pinsOption, goldGiftOption, address, }) => memdbRequest.post(`/club/${clubId}/order-gift`, {
    body: { giftOption, pinsOption, goldGiftOption, address },
});
export const orderExtraPins = ({ clubId, pinsOption, address, }) => memdbRequest.post(`/club/${clubId}/order-extra-pins`, {
    body: { pinsOption, address },
});
export const updateClubCheckValue = ({ updated: _updated, ...clubCheckValue }) => memdbRequest.post(`/club/${clubCheckValue.clubid}/club-check-value`, { body: { clubCheckValue } });
export const deleteClubCheckValue = ({ clubid, year, referenceid, }) => memdbRequest.delete(`/club/${clubid}/club-check-value/${year}-${referenceid}`);
export const sendMail = ({ request, clubId, }) => memdbRequest.post(`/club/${clubId}/mail`, {
    body: JSON.stringify(request),
    headers: {
        "Content-Type": "application/json",
    },
});
export function getClubsByFilter({ years, districtId, city, municipality, schema, }) {
    return memdbRequest.get("/club/filter", {
        params: {
            years: years.join(","),
            ...(districtId !== undefined && { districtId }),
            ...(city !== undefined && { city }),
            ...(municipality !== undefined && { municipality }),
            schema,
        },
    });
}
//# sourceMappingURL=club.js.map